import { appHttpInterceptor } from './shared/interceptors/app-http.interceptor';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideTranslate } from './shared/providers/translate';
import { routes } from './app.routes';
import { SharedModule } from './shared/shared.module';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([appHttpInterceptor])),
    provideTranslate(),
    provideEnvironmentNgxMask({
      validation: false,
      specialCharacters: ['-'],
      dropSpecialCharacters: false
    }),
    importProvidersFrom(SharedModule)
  ]
};